import type { FormEvent } from 'react';
import React from 'react';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { LEAD_BASED_PAINT } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function LeadBasedPaintHazards_v1({ section, setSectionValues }: Props): JSX.Element {
  function onLeadPaintOnPropertyYesClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_ON_PROPERTY]: true,
    });
  }

  function onLeadPaintOnPropertyNoClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_ON_PROPERTY]: false,
    });
  }

  function onRelatedReportsYesClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_RELATED_REPORTS]: true,
    });
  }

  function onRelatedReportsNoClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_RELATED_REPORTS]: false,
    });
  }

  function onDescriptionChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  function onApplicableChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.REPORTS_DESCRIPTION]: value,
    });
  }

  const leadPaintOnProperty = section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.HAS_ON_PROPERTY);
  const relatedReports = section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.HAS_RELATED_REPORTS);

  return (
    <FormField
      label={<Label size="lg">Do you know of any lead-based paint on the property?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onLeadPaintOnPropertyYesClick}
          noHandler={onLeadPaintOnPropertyNoClick}
          yesActive={leadPaintOnProperty}
        >
          <>
            <FormField
              marginBottom="sm"
              label={<Label>Describe where on the property</Label>}
              control={
                <Textarea
                  placeholder="(example: All doors and trim are assumed to have traces of lead paint.)"
                  onChange={onDescriptionChange}
                  value={section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.DESCRIPTION)}
                  resize="vertical"
                />
              }
            />
            <FormField
              label={<Label>Do you know of any reports related to the property and lead-based paint?</Label>}
              control={
                <YesAndNoExpansion
                  yesHandler={onRelatedReportsYesClick}
                  noHandler={onRelatedReportsNoClick}
                  yesActive={relatedReports}
                >
                  <FormField
                    label={<Label>List all applicable document names</Label>}
                    control={
                      <Textarea
                        onChange={onApplicableChange}
                        value={section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.REPORTS_DESCRIPTION)}
                        resize="vertical"
                      />
                    }
                    description={
                      <FormHelp>
                        You must provide copies of the reports when you give the lease to your tenants
                      </FormHelp>
                    }
                  />
                </YesAndNoExpansion>
              }
            />
          </>
        </YesAndNoExpansion>
      }
    />
  );
}
